import { render, staticRenderFns } from "./Taxonomy.vue?vue&type=template&id=4a448385"
import script from "./Taxonomy.vue?vue&type=script&lang=js"
export * from "./Taxonomy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a448385')) {
      api.createRecord('4a448385', component.options)
    } else {
      api.reload('4a448385', component.options)
    }
    module.hot.accept("./Taxonomy.vue?vue&type=template&id=4a448385", function () {
      api.rerender('4a448385', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Taxonomy.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Taxonomy.vue
// module id = 20
// module chunks = 0